import { render, staticRenderFns } from "./AddBenefit.vue?vue&type=template&id=5fc44fbe&scoped=true"
import script from "./AddBenefit.vue?vue&type=script&lang=js"
export * from "./AddBenefit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc44fbe",
  null
  
)

export default component.exports